import { makeCrudStateActionFactories } from "seneca-common/utils/apiStates";

import { locationsCrudStateConfig } from "../consts";

export const { fetchAllActionFactory: fetchAllLocationsActionFactory } =
  makeCrudStateActionFactories(locationsCrudStateConfig);
